import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type UseCompleteEncounterPayload = {
  encounterId: string;
  encounterPhase: 'pre-chart' | 'in-visit';
};

export const useCompleteEncounter = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['completeEncounter'],
    mutationFn: ({
      encounterId,
      encounterPhase,
    }: UseCompleteEncounterPayload) =>
      ambientApi
        .post(
          `/encounters/${encounterId}/complete`,
          {},
          {
            params: {
              encounter_phase: encounterPhase,
            },
          }
        )
        .then((res) => res.data),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: ['encounterDetails', payload.encounterId],
      });
    },
  });
};
